import { randomColors, apiRes } from '../constants';
import { PROFILE_FIELDS } from '../constants/profileFields';
import getConfig from 'next/config';
import { calculateFinances } from '../constants/recommendationData';
import queryString from 'query-string';
import base64 from 'base-64';
const { publicRuntimeConfig } = getConfig();
import { nfoDetails } from '../query/nfo';
import { apolloFetch } from '../configs/apollo';

// require('isomorphic-fetch');

// import {VARIANT_TO_PLAN} from '../constants/f2sV2CardData';
// console.log(VARIANT_TO_PLAN)

// FIXME: The above import is giving error __WEBPACK_IMPORTED_MODULE_3__api__.a is not a constructor. Till then copied it and pasted it here
// import { LayoutServiceConfig } from '../constants/layoutServiceConst';
import { singleFundPageStructure } from '../constants/singleFundPageStructure';
import { getIsLoggedInCookie } from './sessionUtil';

const VARIANT_TO_PLAN = {
  TS: '19',
  BFD: '20',
  GR: '22',
  BG: '25',
  GW: '26',
};

export async function handlePageDataRequests(ctx: any, api: any) {
  const { query, pathname } = ctx;
  const path = query.detailsSlug ? 'details' : pathname;
  return handlePathNames(ctx, path, api);
}

export function getReturnTimeHeader(returnTimeHeading: string) {
  let returnTime = '5Y Returns';

  if (returnTimeHeading === 'return1mth') {
    returnTime = '1M Returns';
  }
  if (returnTimeHeading === 'return3mth') {
    returnTime = '3M Returns';
  }
  if (returnTimeHeading === 'return6mth') {
    returnTime = '6M Returns';
  }
  if (returnTimeHeading === 'return1yr') {
    returnTime = '1Y Returns';
  }
  if (returnTimeHeading === 'return3yr') {
    returnTime = '3Y Returns';
  }
  if (returnTimeHeading === 'return5yr') {
    returnTime = '5Y Returns';
  }

  return returnTime;
}

/** USER CURRENT SESSION */
export async function getUserSession(api: any) {
  let userInfo = null;
  const response = await api.getCurrentUser();
  if (response && response.success) {
    userInfo = response.response;
    if (typeof ga !== 'undefined' && userInfo.externalId) {
      ga('set', 'userId', userInfo.externalId);
    }
  }
  return userInfo;
}

function handlePathNames(ctx: any, path: string, api: any) {
  let response = {};
  switch (path) {
    case '/':
      response = handleLoggedInUserHomePage(ctx, api);
      break;
    case 'details':
      response = handlePersonalInfoData(ctx, api);
      break;
    case '/plan':
      response = handlePlanDetailsPage(ctx, api);
      break;
    case '/plan-v2':
      response = handlePlanDetailsPageV2(ctx, api);
      break;
    case '/payment':
      response = handlePaymentSuccessPage(ctx, api);
      break;
    case '/complete-kyc':
      response = handleKycPage(ctx, api);
      break;
    case '/dashboard':
      response = handleDashboardPage(ctx, api);
      break;
    case '/mandate':
      response = handleMandatePage(api);
      break;
    case '/mandate-status':
      response = handleMandateStatusPage(api);
      break;
    case '/referral':
    case '/special-referral':
      response = handleReferralPage(api);
      break;

    case '/profile':
      response = handleProfilePage(api);
      break;

    case '/single-fund':
    case 'single-fund-slug':
    case 'single-fund-nfo':
    case 'single-fund-slug-nfo':
    case 'single-fund-mutual-funds':
    case 'single-fund-slug-mutual-funds':
    case 'single-fund-nfo-mutual-funds':
    case 'single-fund-slug-nfo-mutual-funds':
      response = handleFundPage(ctx, api);
      break;

    case '/amcs':
      response = handleAmcPage(api);
      break;

    case '/amc':
    case '/amc-mutual-funds':
      response = handleSingleAmcPage(ctx, api);
      break;
    case '/redeemSummary':
      response = handleRedeemSummaryPage(ctx, api);
      break;

    case '/whatsapp-confirmation':
      response = handleWhatsappConfirmationPage(api);
      break;

    case '/complete-payment':
      response = handleCompletePaymentUrl(api);
      break;

    case '/f2s':
      response = handleF2SPage(ctx, api);
      break;

    case '/personalized-plan':
      response = handleF2SPage(ctx, api);
      break;

    case '/status':
      response = handleStatusPage(api);
      break;

    case '/indexMobile':
      response = handleIndexMobilePage(api);
      break;

    case '/invest':
      response = handleInvestPage(ctx, api);
      break;

    case '/sip-calculator':
      response = handleSipCalculator(ctx);
      break;
    default:
  }
  return response;
}

// redirect /save sip-calculator page to /s page
export function handleSipCalculator({ res }: any) {
  res.redirect(301, 'https://cleartax.in/s/sip-calculator');
  res.end = 'Redirected';
  res.finished = true;
  return 'redirect';
}

export async function handleSingleAmcPage({ query, res }: any, api: any) {
  const { slug } = query;
  try {
    const amcDetail = await api.getSingleAmc(slug);
    const amcBasicsDetails = await api.getSingleAmcBasicData(slug);
    /**
     * res.redirect only on server
     */
    if (res && amcDetail.redirectRequired) {
      res.redirect(302, `/mutual-funds/${amcDetail.slug}`);
      res.end = 'Redirected';
      res.finished = true;
      return 'redirect';
    }
    return {
      primarySlug: amcDetail.slug,
      slug: amcDetail.secondarySlug,
      funds: amcDetail.funds,
      issuingAuthority: amcDetail.issuingAuthority,
      customContent: amcDetail.customContent,
      amcBasicsDetails,
    };
  } catch (error) {
    res.statusCode = 404;
    return {
      statusCode: 404,
      slug: '',
      funds: [],
    };
  }
}

export async function handleAmcPage(api: any) {
  const amcs = await api.getAllAmcs();
  return {
    amcs,
  };
}

export const getFundDetailsGraphql = (
  query: any,
  fundIsin?: any,
  planType?: string
) => {
  const variablesObj = { fundIsInCode: fundIsin || '' };
  if (planType) {
    variablesObj.planType = planType;
  }
  return apolloFetch({
    query,
    variables: variablesObj,
  });
};

export const getPageJson = async () => {
  return singleFundPageStructure;
  // return fetch(
  //   `${
  //     LayoutServiceConfig(publicRuntimeConfig.env).apiUrl
  //   }pages/components?project=clearsave&pagename=singleFund`,
  //   {
  //     method: 'GET', // or 'PUT'
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   }
  // )
  //   .then((response) => response.json())
  //   .then((data) => {
  //     return data.data.componentTree;
  //   });
};

export async function handleFundPage(ctx: any, api: any) {
  const { query, res } = ctx;

  const pageData = await getPageJson();
  try {
    const { fundIsin, planType = 'GROWTH' } = query;
    let fundDetails;
    let productId;
    let hasUserInvestedInProduct = false;
    let schemaData;
    let distributionData;
    try {
      const resp: any = await getFundDetailsGraphql(
        nfoDetails,
        fundIsin,
        planType
      );
      if (resp && resp.data && resp.data.fundDetailv2) {
        fundDetails = resp.data.fundDetailv2;
        productId = resp.data.fundDetailv2.id;
      } else {
        return {
          statusCode: 404,
          selectedFund: {},
        };
      }
    } catch (e) {}

    if (productId) {
       if(typeof window !== 'undefined' && getIsLoggedInCookie() === 'true'){
      await api.getUserInvestmentInProduct(productId).then((response) => {
        hasUserInvestedInProduct =
          response && response.status === 200 ? true : false;
      });
    }
    }

    try {
      schemaData = await api.getFundSchemaDetails(fundIsin);
      if (schemaData && schemaData.success) {
        fundDetails.expenseRatioDate = schemaData.data.expenseRatioDate;
        fundDetails.inceptionDate = schemaData.data.launchDate;
        fundDetails.fundBenchmark = schemaData.data.fundBenchmark;
        fundDetails.fundType = schemaData.data.fundType;
      }
    } catch (e) {}

    try {
      distributionData = await api.getFundDistribution(fundIsin);
      if (distributionData && distributionData.success) {
        fundDetails.assetAllocation = distributionData.data;
      }
    } catch (e) {}

    return {
      pageData,
      selectedFund: fundDetails || null,
      fundData: {},
      hasUserInvestedInProduct,
    };
  } catch (error) {
    /**
     * This should catch error in getFundById or getFundDetails
     * If any of those API fails then fund not found
     */
    if (res) {
      res.statusCode = 404;
    }
    return {
      statusCode: 404,
      fundData: { returns: {}, latestNav: {}, amcBasic: {}, schemaMaster: {} },
    };
  }
}
/**
 * USER info page request handler
 */
export async function handlePersonalInfoData(ctx: any, api: any) {
  const { req, res, query } = ctx;
  const { amcSlug, fundIsin, planType = 'GROWTH' } = query;

  const pageData = await getPageJson();
  let fundDetails;
  let fundData;
  if (amcSlug && fundIsin) {
    fundData = await api.getFundById(fundIsin, 'ISIN');
    const resp = await getFundDetailsGraphql(nfoDetails, fundIsin, planType);
    if (resp && resp.data && resp.data.fundDetailv2) {
      fundDetails = resp.data.fundDetailv2;
    }
  }
  try {
    const [bucketDetails, userDetails] = await Promise.all([
      query.id ? api.getBucketDetails(query.id) : {},
      api.getUserDetails(),
    ]);
    if (!userDetails || !userDetails.success) {
      redirectToLoginPage(req, res);
      return {};
    }
    return {
      bucketData: (bucketDetails || {}).response || {},
      errors: userDetails.response.errors,
      entity: userDetails.response.entity,
      selectedFund: fundDetails || null,
      fundData,
      pageData,
    };
  } catch (e) {
    redirectToLoginPage(req, res);
  }
}

/**
 * PLAN DETAILS page
 */
async function handlePlanDetailsPage(ctx: any, api: any) {
  const { query } = ctx;
  const bucketDetails = await api.getBucketDetails(query.id);

  return {
    bucketData: bucketDetails.response,
  };
}

async function handlePlanDetailsPageV2(ctx: any, api: any) {
  /**
   * TODO: what is the desired behaviour when this is called via client?
   * calling res.redirect on client will result in error
   */
  const { query, res } = ctx;
  const bucketDetails = await api.getBucketDetails(query.id);
  const { bucketId } = bucketDetails.response.sections;
  res.redirect(301, `/save/plan/${bucketId}`);
  res.end = 'Redirected';
  res.finished = true;
  return {
    bucketData: bucketDetails.response,
  };
}

async function handleProfilePage(api: any) {
  const userDetails = await api.getUserDetails();
  const userBankAccounts = await api.getAllBankAccounts();
  return {
    errors: userDetails.response.errors,
    entity: userDetails.response.entity,
    userBankAccounts,
  };
}

async function handleRedeemSummaryPage(ctx: any, api: any) {
  const { query } = ctx;
  const [userDetails, transactionRes] = await Promise.all([
    api.getUserDetails(),
    api.getTransactions(query.id),
  ]);

  return {
    transactionData: transactionRes.response,
    entity: userDetails.response.entity,
  };
}

async function handleLoggedInUserHomePage(ctx: any, api: any) {
  const userInfo = await getUserSession(api);
  if (userInfo) {
    return handleDashboardPage(ctx, api);
  }
  return {};
}

async function handleDashboardPage(ctx: any, api: any) {
  const { query } = ctx;
  let paymentData = {};
  // TODO: need to combine these api in backend.
  const [transactionRes, mandateList, userDetails] = await Promise.all([
    api.getTransactions(query.id),
    api.getMandatesList(),
    api.getUserDetails(),
  ]);

  if (query.paymentId) {
    const response = await api.getPaymentData(query.paymentId);
    paymentData = response;
  }

  return {
    transactionData: transactionRes.response || {},
    mandateList,
    paymentData,
    userDetails,
  };
}

/**
 * Mandate status page
 */
async function handleMandateStatusPage(api: any) {
  const mandateList = await api.getMandatesList();
  return {
    mandateList,
  };
}

/**
 * Mandate page
 */
async function handleMandatePage(api: any) {
  const [mandateInfo, mandateList, userBankAccounts] = await Promise.all([
    api.getMandateInfo('DIRECT'),
    api.getMandatesList(),
    api.getAllBankAccounts(),
  ]);
  const verifiedBankAccounts = userBankAccounts.filter((bank) => bank.verified); // To show only verfied bank accounts
  return {
    mandateInfo,
    mandateList,
    userBankAccounts: verifiedBankAccounts,
  };
}

/**
 * Referral Page
 */

async function handleReferralPage(api: any) {
  const referralInfo = await api.getReferCode();
  const { referralCode } = referralInfo.response;
  return {
    referralCode,
  };
}

/**
 * PAYMENT SUCCESS page
 */

async function handlePaymentSuccessPage(ctx: any, api: any) {
  const { query } = ctx;
  const response = await api.getPaymentData(query.externalId);
  return { paymentData: response };
}

/**
 * Whatsapp Confirmation
 */
async function handleWhatsappConfirmationPage(api: any) {
  const userDetails = await api.getUserDetails();

  return {
    errors: userDetails.response.errors,
    entity: userDetails.response.entity,
  };
}

async function handleCompletePaymentUrl(api: any) {
  let response;
  let success;
  try {
    const call = await api.getIncomplePayementCartDetails();
    response = call.response;
    success = call.success;
    if (success) {
      const { sourceValue, items } = response;
      const { itemType } = items[0];
      const sourceTypeMap = {
        'top-funds': 'fund',
        'single-fund': 'fund',
        plan: 'plan',
      };
      const urlParams = {
        amount: response.totalAmount,
        investmentType: itemType,
      };
      const qs = queryString.stringify(urlParams);
      const sourceType = sourceTypeMap[response.sourceType];
      const url = `/save/invest/${sourceType}/${sourceValue}?${qs}`;
      return {
        forceRedirect: true,
        redirectURL: url,
      };
    }
  } catch (e) {
    const { status } = e;
    // if it is a 401 error then redirect to login with reference to complete-payment
    if (status === 401) {
      return {
        forceRedirect: true,
        redirectURL: `/save/login?refer=%2Fsave/complete-payment`,
      };
    }
    return {
      forceRedirect: true,
      redirectURL: `/save`,
    };
  }
}

/**
 * Redirection based on segment - F2S
 */
async function handleF2SPage(ctx: any, api: any) {
  const { req, query } = ctx;
  const { f2s_version } = query;
  const config = getConfig();
  const env = config.publicRuntimeConfig.env;
  let userData;
  let apiResponse;
  if (env === 'development' || env === 'dev') {
    apiResponse = apiRes;
  } else {
    const response = await api.getUserFilingDetails();
    apiResponse = response;
  }

  const currentYear = new Date().getFullYear();
  const userAge = currentYear - Number(apiResponse.YearOfBirth);
  let ageGroup;
  if (userAge < 30) {
    ageGroup = 'below30';
  } else if (userAge >= 30 && userAge < 50) {
    ageGroup = 'between30-50';
  } else {
    ageGroup = 'above50';
  }

  const {
    Deduction80C,
    TaxableSalary,
    Deduction80DInsurance,
    Deduction80DHealthCheck,
  } = apiResponse;
  const data = {
    investments80C: Deduction80C,
    taxableSalary: TaxableSalary,
    deduction80DInsurance: Deduction80DInsurance,
    deduction80DHealthCheck: Deduction80DHealthCheck,
  };
  const taxableSalary = apiResponse.TaxableSalary;
  userData = calculateFinances(data);
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const index = Math.floor(Math.random() * 10);
  const pathname = req
    ? req.originalUrl
    : `${location.pathname}${location.search}`;
  const isNewF2S = /2019-v[0-9]/.test(pathname);
  const isGoalBasedF2S = /2019-v5/.test(pathname);
  const basePathname =
    pathname.indexOf('/save/f2s') === -1
      ? '/save/personalized-plan/'
      : '/save/f2s/';

  if (!isNewF2S && taxableSalary === 0) {
    return {
      forceRedirect: true,
      redirectURL: `${basePathname}2019-v2`,
    };
  }
  // NOTE: Wherever startInvest is used in the codebase it is hardcoded as 1
  if (taxableSalary <= 700000) {
    if (isGoalBasedF2S) {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_a?variant=${variant}&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    }
    if (arr[index] <= 5) {
      const variant = 'TS';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_a?variant=${variant}&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    } else {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_a?variant=${variant}&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    }
  } else if (taxableSalary > 700000 && taxableSalary <= 1500000) {
    if (isGoalBasedF2S) {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_b?variant=${variant}&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    }
    if (userData.taxSavings < 10000) {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_b?variant=${variant}&tsa=below10000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    } else {
      if (arr[index] <= 5) {
        const variant = 'TS';
        const planId = VARIANT_TO_PLAN[variant];
        return {
          redirectURL: `${basePathname}${f2s_version}/segment_b?variant=${variant}&tsa=above10000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
          taxableSalary,
          investments80C: Deduction80C,
        };
      } else {
        const variant = 'GW';
        const planId = VARIANT_TO_PLAN[variant];
        return {
          redirectURL: `${basePathname}${f2s_version}/segment_b?variant=${variant}&tsa=above10000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
          taxableSalary,
          investments80C: Deduction80C,
        };
      }
    }
  } else if (taxableSalary > 1500000) {
    if (isGoalBasedF2S) {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_c?variant=${variant}&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    }
    if (userData.taxSavings < 20000) {
      const variant = 'GW';
      const planId = VARIANT_TO_PLAN[variant];
      return {
        redirectURL: `${basePathname}${f2s_version}/segment_c?variant=${variant}&tsa=below20000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
        taxableSalary,
        investments80C: Deduction80C,
      };
    } else {
      if (arr[index] <= 5) {
        const variant = 'TS';
        const planId = VARIANT_TO_PLAN[variant];
        return {
          redirectURL: `${basePathname}${f2s_version}/segment_c?variant=${variant}&tsa=above20000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
          taxableSalary,
          investments80C: Deduction80C,
        };
      } else {
        const variant = 'GW';
        const planId = VARIANT_TO_PLAN[variant];
        return {
          redirectURL: `${basePathname}${f2s_version}/segment_c?variant=${variant}&tsa=above20000&ageGroup=${ageGroup}&screen=1&startInvest=1&planId=${planId}`,
          taxableSalary,
          investments80C: Deduction80C,
        };
      }
    }
  }
}

async function handleStatusPage(api: any) {
  const userStatusDetails = await api.getUserStatusDetails();
  const initialProps = {
    userStatusDetails,
  };
  return initialProps;
}

async function handleIndexMobilePage(api: any) {
  const plans = ['19', '26', '20'];
  const bucketDataPromises = plans.map((id) => {
    return api.getBucketDetails(id);
  });

  const bucketDetailsResponse = await Promise.all(bucketDataPromises);

  const bucketDetails = bucketDetailsResponse.map((res) => {
    const { response } = res;
    return response;
  });

  return {
    bucketDetails,
  };
}

async function handleInvestPage(ctx: any, api: any) {
  const { req } = ctx;
  let bucketDetails = null;
  let fundDetails = null;
  const userDetails = await api.getUserDetails();
  const splitUrl = (req.url || '').split('/');
  const investIn = splitUrl[3];
  const investInID = splitUrl[4];
  if (investIn === 'plan') {
    bucketDetails = await api.getBucketDetails(investInID);
  }
  if (investIn === 'fund') {
    fundDetails = await api.getFundDetails(investInID);
  }

  const initialProps = {
    entity: userDetails.response.entity,
    bucketDetails: bucketDetails && bucketDetails.response,
    fundDetails,
  };
  return initialProps;
}

/**
 * KYC PAGE REQUESTS
 */
async function handleKycPage(ctx: any, api: any) {
  const { req, res } = ctx;
  const userDetails = await api.getUserDetails();
  if (!userDetails.success) {
    redirectToLoginPage(req, res);
    return {};
  }

  const initialProps = {
    errors: userDetails.response.errors,
    entity: userDetails.response.entity,
  };
  return initialProps;
}

// async function handleHomePage(ctx: any, api: any) {

// }

export function displayReadabledate(str: string) {
  const date = new Date(str);
  return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
}

function replaceDetailsSlug(str: string) {
  return str.replace(/(\?detailsSlug=(first|second|third|payment))/g, '');
}

export function redirectToLoginPage(req?: any, res?: any) {
  const pathname = req
    ? req.originalUrl
    : `${location.pathname}${location.search}`;
  const url = `/save/login?refer=${encodeURIComponent(
    replaceDetailsSlug(pathname)
  )}`;

  let loginHref;
  let returnPath;
  switch (publicRuntimeConfig.env) {
    case 'development':
      loginHref = url;
      // returnPath = base64.encode(
      //   `${currentPath}`
      // );
      // loginHref = `https://sso-dev-http.internal.cleartax.co/?product=save&return_path=${returnPath}`;
      break;
    case 'staging':
      loginHref = url;
      // returnPath = base64.encode(
      //   `${currentPath}`
      // );
      // loginHref = `https://sso-staging-pub.internal.cleartax.co/?product=save&return_path=${returnPath}`;
      break;
    case 'production':
      returnPath = base64.encode(`${replaceDetailsSlug(pathname)}`);
      loginHref = `https://accounts.cleartax.in/?product=save&return_path=${returnPath}`;
      break;
    default:
      loginHref = url;
  }

  if (res) {
    res.redirect(loginHref);
    res.end();
    res.finished = true;
  } else {
    window.location.href = loginHref;
  }
}

export function hideScroll() {
  try {
    document.querySelectorAll('body, html').forEach((el: any) => {
      el.style.overflow = 'hidden';
    });
  } catch (err) {
    /* notify failure */
  }
}

export function showScroll() {
  try {
    document.querySelectorAll('body, html').forEach((el: any) => {
      el.style.overflow = 'auto';
    });
  } catch (err) {
    /* notify failure */
  }
}

export function zeroPad(num: any) {
  const value = Number(num);
  return value > 9 ? `${value}` : `0${value}`;
}

export function isObjectEmpty(obj: object) {
  obj = obj || {};
  let hasAKey = true;
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      hasAKey = false;
      break;
    }
  }
  return hasAKey;
}

export function showError(text: string) {
  if (typeof window !== 'undefined') {
    const template = `<div>
      <div class='notification-base failure-notification'>
        <div>
          <div class="notification-content">${text}</div>
            <a id="error-close-icon" class="close-icon" />
          </div>
        </div>
      </div>`;

    const errorDiv = document.createElement('div');
    errorDiv.id = 'error-div';
    errorDiv.innerHTML = template;
    document.body.appendChild(errorDiv);
    document.querySelector('body').addEventListener('click', (e: Event) => {
      // e.preventDefault();
      if (e.target.getAttribute('id') === 'error-close-icon') {
        const error = document.getElementById('error-div');
        if (error) {
          error.remove();
        }
      }
    });
  }
}

export function showNotification(text: string, notificationClass: string) {
  if (typeof window !== 'undefined') {
    const template = `<div>
      <div class='notification-base ${notificationClass}'>
        <div>
          <div class="notification-content">${text}</div>
            <a id="notification-close-icon" class="close-icon" />
          </div>
        </div>
      </div>`;

    const notificationDiv = document.createElement('div');
    notificationDiv.id = 'notification-div';
    notificationDiv.innerHTML = template;
    document.body.appendChild(notificationDiv);
    document.querySelector('body').addEventListener('click', (e: Event) => {
      if (e.target.getAttribute('id') === 'notification-close-icon') {
        e.preventDefault();
        const error = document.getElementById('notification-div');
        if (error) {
          error.remove();
        }
      }
    });
  }
}

export function getParameterByName(name: string, url: string) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (results && results[2]) {
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return '';
}

// Used to validate DD/MM/YYYY format date
export function checkValidDate(val: string) {
  if (!val) {
    return false;
  }
  const dateReg = new RegExp(
    /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/
  );
  return dateReg.exec(val) !== null;
}

export function addScriptDynamically(url: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;

    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${url}`));

    document.body.appendChild(script);
  });
}

export function addCSSDynamically(url: string) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';

    link.onload = () => resolve(link);
    link.onerror = () => reject(new Error(`CSS load error for ${url}`));

    document.head.appendChild(link);
  });
}

/* TODO mayanak will define proper types for this function */
export function createCookie(name: any, value: any, days: any) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  } else {
    expires = '';
  }
  return `${name}=${value}${expires};`;
}

export function patternItem(x: number, lastNum: number) {
  return x % lastNum;
}

let count = 0;
export const generateRandomColor = () => {
  const color = randomColors[patternItem(count, randomColors.length)];
  count++;
  return color;
};

export const calcualateValue = (key: string, value: any) => {
  const field = PROFILE_FIELDS[key];
  if (!value) {
    return '-NA-';
  } else if (field) {
    return field.formatter ? field.formatter(value) : value;
  }
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export const capitalizeFirstLetter = (str: string) => {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.toString().slice(1);
};

export const amcTitleCase = (amcName: string) => {
  const ACRONYMS = new Set(['SBI', 'HDFC', 'ICICI', 'UTI', 'IDFC', 'DSP']);
  let words = amcName.split(' ').map((word) => {
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
  words = words.map((word) => {
    if (ACRONYMS.has(word.toUpperCase())) {
      return word.toUpperCase();
    }
    return word;
  });
  return words.join(' ');
};

export const starImage = (num: any) => {
  const n = Math.floor(Number(num));
  return (
    <div className="lil-flex lil-items-center">
      {Array(n)
        .fill(n)
        .map(() => {
          return (
            <span className="lil-mr-1 sm:lil-mr-0">
              <img
                src="https://assets1.cleartax-cdn.com/cleartax/images/1631168834_star.svg"
                alt="star"
              />
            </span>
          );
        })}
      <span className="lil-pl-2 sm:lil-pl-1">{num}</span>
    </div>
  );
};

export const isDescendant = (parentId: string, child: any) => {
  let node = child.parentNode;
  while (node !== null) {
    if (node.id === parentId) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export const handleABRedirection = (
  ctx: any,
  redirectionInfoArr: any // [{dest: 'new url', weight: 20}, ...] leftout weight will not be redirected
) => {
  const { req, res, query, asPath } = ctx;
  const { headers } = req;
  const randomNumber = Math.floor(Math.random() * 100) + 1;
  const cookieName = `invest-ab-redirect${
    asPath.indexOf('?') === -1
      ? asPath.replace(/\//g, '-')
      : asPath.slice(1, asPath.indexOf('?')).replace(/\//g, '-')
  }`;
  let cookieObj;
  if (headers.cookie) {
    cookieObj = headers.cookie.split('; ').reduce((prev, current) => {
      const [name, value] = current.split('=');
      prev[name] = value;
      return prev;
    }, {});
  }

  let prevWeight = 0;
  const { id, ...queryObj } = query;
  const queryStr = queryString.stringify(queryObj);

  if ((cookieObj && !cookieObj[cookieName]) || !headers.cookie) {
    redirectionInfoArr.forEach((data) => {
      if (
        randomNumber > prevWeight &&
        randomNumber <= parseInt(data['weight'], 10) + prevWeight
      ) {
        const redirectUrl = data['dest'];
        res.cookie(cookieName, redirectUrl);
        res.redirect(302, `${redirectUrl}${queryStr ? '?' + queryStr : ''}`);
      } else {
        res.cookie(cookieName, 'stay');
      }
      prevWeight = parseInt(data['weight'], 10) + prevWeight;
    });
  } else if (cookieObj && cookieObj[cookieName] !== 'stay') {
    res.redirect(
      302,
      `${decodeURIComponent(cookieObj[cookieName])}${
        queryStr ? '?' + queryStr : ''
      }`
    );
  }
};

export const getNextMonthDate = (date: string) => {
  const newDate = new Date(date);
  return new Date(newDate.setMonth(newDate.getMonth() + 1));
};

export const calculateAge = (birthday) => {
  // birthday is a date
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const getNextThirtyDays = (date: string) => {
  const fromDate = new Date(date);

  const year = fromDate.getFullYear();
  const month = fromDate.getMonth();
  const day = fromDate.getDate();

  const dateArr = [];

  for (let i = 0; i < 30; i++) {
    dateArr.push(new Date(year, month, day + i));
  }
  return dateArr;
};

export const maskAccountNo = (accNo = '') => {
  // Here we have to show only last 4 digit of account no.
  const lengthAccNo = accNo.length;
  // get last 4 digit of acc no.
  const lastFour = accNo.slice(lengthAccNo - 4);

  let maskedString = '';
  let counter = lengthAccNo - 4;

  while (counter > 0) {
    maskedString = maskedString + '*';
    counter--;
  }

  maskedString = maskedString + lastFour;

  return maskedString;
};



// WEBPACK FOOTER //
// ./utils/index.tsx